import React from "react";
import moment from 'moment-timezone';
import { Link } from 'react-router-dom'

export class TournamentDetailsPhone extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      tournament: this.props.tournament,
      day1: '',
      day2: '',
      day3: '',
      day4: '',
      meetingTime: ''
    }
  }
  
  componentWillReceiveProps(newProps) {
		var day1 = new Date(newProps.tournament.tourDay1);
		var day2 =  new Date(newProps.tournament.tourDay2);
		var day3 =  new Date(newProps.tournament.tourDay3);
		var day4 =  new Date(newProps.tournament.tourDay4);
		var meetingTime = new Date(newProps.tournament.captMeetingTime);
		
    this.setState({
      tournament: newProps.tournament,
      day1: this.setDates(day1),
      day2: this.setDates(day2),
      day3: this.setDates(day3),
      day4: this.setDates(day4),
      meetingTime: this.setDates(meetingTime)
    })
  }
	
	setDates(date) {
		if(this.state.tournament.tournamentTimeZone) {
			var newDate = moment(date).tz(this.props.tournament.tournamentTimeZone).format('lll');
			return newDate;
		}
	}
  
  countProperties(obj) {
    var count = 0;

    for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
            ++count;
    }

    return count;
}
  
  render() {
    return (
      <div className="details-container-phone">
        <div className="details-name-phone">{this.props.tournament.tournamentName}</div>
        <div className="details-venue-phone">{this.props.tournament.venue}</div>
        <div className="details-text-phone">Capt. Meeting Location: {this.props.tournament.captMeetingLoc}</div>
        <div className="details-meetTime-phone">Capt. Meeting Time: {this.state.meetingTime}</div>
        {this.state.day1 ? <div className="details-text-phone">Day 1 Lines In: { this.state.day1 }</div>: null}
        {this.props.tournament.tourDay2 ? <div className="details-text-phone">Day 2 Lines In: { this.state.day2 }</div> : null}
        {this.props.tournament.tourDay3 ? <div className="details-text-phone">Day 3 Lines In: { this.state.day3 }</div>: null}
        {this.props.tournament.tourDay4 ? <div className="details-text-phone">Day 4 Lines In: { this.state.day4 }</div> : null}
        
     </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/qbc/comps/TournamentDetailsPhone.js